// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextArea_textArea__2hwOD"};